import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { RunLogs } from "../components/RunLogs";
import { Terminal, ChevronRight } from "lucide-react";

export default function Logs() {
  const [runs, setRuns] = useState([]);

  const reload = async () => {
    const rs = await api.ingestRuns(100);
    setRuns(rs.runs);
  };

  // Mount-only — reload reads only stable refs (api + setter)
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { reload(); }, []);

  return (
    <div className="space-y-5">
      <div className="border-b border-white/10 pb-4 flex flex-wrap items-end justify-between gap-4">
        <div>
          <div className="label-mono text-bm-amber flex items-center gap-2">
            <Terminal className="w-3.5 h-3.5" />SCRAPE LOGS
          </div>
          <h1 className="font-heading text-4xl font-black tracking-tight mt-1" data-testid="page-title">
            Every run, on the record.
          </h1>
          <p className="text-sm text-bm-muted mt-2 max-w-3xl">
            Full audit trail of every channel crawl — which scrapes succeeded, which failed, and the exact error.
          </p>
        </div>
        <Link to="/ingest" data-testid="open-ingestion-link"
          className="flex items-center gap-1.5 px-2.5 py-1 text-xs font-mono text-bm-amber border border-bm-amber/40 hover:bg-bm-amber hover:text-black transition-colors">
          MANAGE ADAPTERS <ChevronRight className="w-3 h-3" />
        </Link>
      </div>
      <RunLogs runs={runs} onRefresh={reload} />
    </div>
  );
}
